module.exports = __webpack_public_path__ + "static/media/ai-slider.c8e6b3b2.png";